import * as actionTypes from '../../actions/actionTypes';

const initialState = {
    personalCVData: null,
    loadingPersonalCVData: false,
    skills: [],
    loadingSkills: false,
};

const loadPersonalCVData = (state) => {
    return {
        ...state,
        loadingPersonalCVData: true
    }
}

const setPersonalCVData = ( state, action ) => {
    let tmp = {...action.personalCVData}
    return {
        ...state,
        personalCVData: tmp,
        loadingPersonalCVData: false
    }
};

const loadSkills = (state) => {
    return {
        ...state,
        loadingSkills: true,
        skills: []
    }
}

const setSkills = (state, action) => {
    return {
        ...state,
        skills: state.skills.concat(action.skillsData),
        loadingSkills: false
    }
};


const updatePhoto = (state, action) => {
    let tmp = {...state.personalCVData}
    tmp.photoUrl = action.src.length !== 0 ? action.src : null

    return {
        ...state,
        personalCVData: {...tmp}
    }
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.LOAD_PERSONAL_CV_DATA: return loadPersonalCVData( state );
        case actionTypes.SET_PERSONAL_CV_DATA: return setPersonalCVData( state, action );
        case actionTypes.LOAD_SKILLS: return loadSkills( state );
        case actionTypes.SET_SKILLS: return setSkills( state, action );
        case actionTypes.UPDATE_PHOTO: return updatePhoto(state, action);
        default: return state;
    }
};
export default reducer;